import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout-options" },
    [
      _c("div", { staticClass: "layout-options__info" }, [
        _c(
          "span",
          { staticClass: "mx-2" },
          [
            _vm.hasActiveLayout
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("grid.layouts.sidebar.currentLayout")) +
                      ":\n        "
                  ),
                  _c("span", { staticClass: "layout-name" }, [
                    _vm._v(_vm._s(_vm.activeLayoutName)),
                  ]),
                ]
              : _c("span", { staticClass: "layout-name--no-layout" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("grid.layouts.sidebar.noActiveLayout")) +
                      "\n      "
                  ),
                ]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-options__buttons" },
        [
          _vm.canEdit && _vm.hasActiveLayout
            ? _c(
                VBtn,
                {
                  staticClass: "mx-1 px-2",
                  attrs: {
                    color: "primary",
                    depressed: "",
                    small: "",
                    height: "24",
                  },
                  on: { click: _vm.updateLayout },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("grid.layouts.sidebar.saveLayout")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "mx-1 px-2",
              attrs: {
                color: "primary",
                outlined:
                  (_vm.canEdit || _vm.isRecommendedLayout) &&
                  _vm.hasActiveLayout,
                depressed: !(
                  (_vm.canEdit || _vm.isRecommendedLayout) &&
                  _vm.hasActiveLayout
                ),
                small: "",
                height: "24",
              },
              on: { click: _vm.openSaveDialog },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    (_vm.canEdit || _vm.isRecommendedLayout) &&
                      _vm.hasActiveLayout
                      ? _vm.$t("grid.layouts.sidebar.saveAsNew")
                      : _vm.$t("grid.layouts.sidebar.saveLayout")
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-dialog", {
        staticClass: "confirm-dialog",
        attrs: {
          "is-open": _vm.saveOpen,
          "ok-btn-text": _vm.$t("actions.save"),
          "cancel-btn-text": _vm.$t("actions.cancel"),
          "disable-ok-button": !_vm.isLayoutNameValid,
        },
        on: { onOk: _vm.saveLayout, onCancel: _vm.closeModal },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("grid.layouts.saveDialog.title")) +
                    "\n      "
                ),
                _c(
                  "div",
                  { staticClass: "layout-save-dialog" },
                  [
                    _c(VTextField, {
                      ref: "layoutNameField",
                      attrs: {
                        label: _vm.$t("grid.layouts.saveDialog.layoutName"),
                        outlined: "",
                        dense: "",
                        rules: _vm.rules,
                      },
                      model: {
                        value: _vm.newLayoutName,
                        callback: function ($$v) {
                          _vm.newLayoutName = $$v
                        },
                        expression: "newLayoutName",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }